import { createReducer } from '../../utils/createReducer';
import { FileContentsState } from '../types';

import {
  SET_FILE_CONTENTS,
  CLEAR_FILE_CONTENTS,
  FileContentsActions,
  SET_SELECTED_FILES,
  CLEAR_SELECTED_FILES,
} from '../actions/types';

const initialState = {
  fileContents: [],
  selectedFiles: [],
};

const fileContentsReducer = {
  [SET_FILE_CONTENTS]: (state: FileContentsState, { payload }) => {
    return { ...state, fileContents: payload };
  },

  [CLEAR_FILE_CONTENTS]: (state: FileContentsState) => ({ ...initialState }),

  [SET_SELECTED_FILES]: (state: FileContentsState, { payload }) => {
    return { ...state, selectedFiles: payload };
  },

  [CLEAR_SELECTED_FILES]: (state: FileContentsState) => ({ ...initialState }),
};

const files = (state: FileContentsState = initialState, action: FileContentsActions) =>
  createReducer(fileContentsReducer, state, action);
export default files;
